// package: user
// file: user/token_service.proto

import * as common_service_options from "../common/service_options";
import * as common_method_options from "../common/method_options";
import * as user_base_model from "../user/base/model";

import { interfaceAPI } from "../sdk/api";

export const NewUserTokenRequestV2 = {
    encode(object) {
        const message = {};
        if (object.type != null) {
            if (object.type !== 0) {
                message.type = object.type;
            }
        }
        if (object.expireSeconds != null) {
            if (object.expireSeconds !== 0) {
                message.expireSeconds = object.expireSeconds | 0;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            type: 0,
            expireSeconds: 0,
        };

        if (message.type != null) {
            object.type = message.type;
        }
        if (message.expireSeconds != null) {
            object.expireSeconds = message.expireSeconds;
        }
        return object;
    },
};

export const NewUserTokenReply = {
    encode(object) {
        const message = {};
        if (object.token != null) {
            if (object.token !== "") {
                message.token = String(object.token);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            token: "",
        };

        if (message.token != null) {
            object.token = message.token;
        }
        return object;
    },
};

export const NewAuthCodeRequest = {
    encode(object) {
        const message = {};
        if (object.token != null) {
            if (object.token !== "") {
                message.token = String(object.token);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            token: "",
        };

        if (message.token != null) {
            object.token = message.token;
        }
        return object;
    },
};

export const NewAuthCodeReply = {
    encode(object) {
        const message = {};
        if (object.code != null) {
            if (object.code !== "") {
                message.code = String(object.code);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            code: "",
        };

        if (message.code != null) {
            object.code = message.code;
        }
        return object;
    },
};

export const GetTokenByAuthCodeRequest = {
    encode(object) {
        const message = {};
        if (object.code != null) {
            if (object.code !== "") {
                message.code = String(object.code);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            code: "",
        };

        if (message.code != null) {
            object.code = message.code;
        }
        return object;
    },
};

export const GetTokenByAuthCodeReply = {
    encode(object) {
        const message = {};
        if (object.token != null) {
            if (object.token !== "") {
                message.token = String(object.token);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            token: "",
        };

        if (message.token != null) {
            object.token = message.token;
        }
        return object;
    },
};

export function NewUserTokenV2(request, options) {
    return interfaceAPI("/user.Token/NewUserTokenV2", NewUserTokenRequestV2.encode(request), NewUserTokenReply, options);
}

export function NewAuthCode(request, options) {
    return interfaceAPI("/user.Token/NewAuthCode", NewAuthCodeRequest.encode(request), NewAuthCodeReply, options);
}

export function GetTokenByAuthCode(request, options) {
    return interfaceAPI("/user.Token/GetTokenByAuthCode", GetTokenByAuthCodeRequest.encode(request), GetTokenByAuthCodeReply, Object.assign({ isAuthFree: 1, }, options));
}


